import classNames from "classnames";
import styles from "../styles/login.module.scss";
import {observer} from "mobx-react";
import {Loader} from "../../../components/loader/loader";
import {shareState} from "../../../app/share-state";

export const LoginWidgetErrorMessageIndicator = observer(({controller}) => {
  const {state} = controller;
  const {showErrorMessage, showErrorUnCheckedBoxMessage, isLoggingIn} = state;

  const errorText = showErrorMessage
    ? shareState.termsUtils.terms.WC_2022_LOGIN_FAILED
    : (showErrorUnCheckedBoxMessage || '');

  const isCocacola = shareState.theme === 'cocacola';
  const errorMessageClass = isCocacola ? styles.error_message_cocacola : styles.error_message;

  return (
    <Loader showLoader={isLoggingIn && !showErrorMessage && !showErrorUnCheckedBoxMessage} className={styles.login_loader} size={20}>
      <div className={classNames(errorMessageClass)}>
        {errorText}
      </div>
    </Loader>
  )
});
